import { DataTable } from "@/components/ui/data-table";
import type { AuditLogRow } from "@/lib/audit-log.api";
import { AUDIT_LOG_EMPTY_MESSAGE } from "../auditLogPage.constants";
import { createAuditLogColumns } from "../auditLogColumns";

interface AuditLogTableProps {
  rows: AuditLogRow[];
  isLoading: boolean;
}

export function AuditLogTable({ rows, isLoading }: AuditLogTableProps) {
  return (
    <DataTable
      columns={createAuditLogColumns()}
      data={rows}
      loading={isLoading}
      emptyMessage={AUDIT_LOG_EMPTY_MESSAGE}
    />
  );
}
